// test892
(892 && 0);
